import { dayjs, UsageStats } from '@solo/app-core';
import { translate } from '@/app/i18n';
import { Flex, Text } from '@/app/ui/atoms';
import Colors from '@/app/styles/Colors';

interface UsageDetailsTableProps {
  usages: UsageStats[];
}

const UsageDetailList = ({ usages }: UsageDetailsTableProps) => (
  <Flex.Container className="table" flexDirection="column">
    <Flex.Container gap="16px" className="thead">
      <Flex.Item flex={2} className="th" style={{ paddingLeft: '1rem' }}>
        <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
          {translate('WORKS.TITLE')}
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item flex={2} className="th">
        <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
          {translate('WORKS.ARTIST')}
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item flex={1} className="th">
        <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
          {translate('DIGITAL_DISTRIBUTION.PLATFORM')}
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item flex={1} className="th">
        <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
          {translate('FORMS.COUNTRY')}
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item flex={1} className="th">
        <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
          {translate('DIGITAL_DISTRIBUTION.DATE')}
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item flex={1} className="th">
        <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
          {translate('USAGES.PLAYS')}
        </Text.Paragraph>
      </Flex.Item>
    </Flex.Container>
    <Flex.Container className="tbody" flexDirection="column" gap="10px">
      {usages.map((usage) => (
        <Flex.Container key={usage.id} className="tr" alignItems="center" gap="16px">
          <Flex.Item flex={2} className="td" style={{ paddingLeft: '1rem' }}>
            <Text.Paragraph style={{ color: Colors.primary }} fontWeight={700}>
              {usage?.title}
            </Text.Paragraph>
          </Flex.Item>
          <Flex.Item flex={2} className="td">
            {usage?.artist}
          </Flex.Item>
          <Flex.Item flex={1} className="td">
            {usage?.platform}
          </Flex.Item>
          <Flex.Item flex={1} className="td">
            {usage?.country}
          </Flex.Item>
          <Flex.Item flex={1} className="td">
            {dayjs(usage?.date).format('DD/MM/YYYY')}
          </Flex.Item>
          <Flex.Item flex={1} className="td">
            {usage.plays}
          </Flex.Item>
        </Flex.Container>
      ))}
    </Flex.Container>
  </Flex.Container>
);

export default UsageDetailList;
